import { Button, Modal } from 'antd';
import intl from '@/internationalzation/intl';
import './ConfirmDeleteModal.less';

const DEFAULT_NAME = 'mario-scheduler-confirm-delete-modal';

export interface ConfirmDeleteModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmDeleteModal = ({
  visible,
  onClose,
  onConfirm,
}: ConfirmDeleteModalProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      className={DEFAULT_NAME}
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      maskClosable={false}
      width={400}
      centered
      destroyOnClose
    >
      <div className={`${DEFAULT_NAME}-body`}>
        <div className={`${DEFAULT_NAME}-content`}>
          {intl.t('确定终止并删除这个定时任务吗？')}
        </div>
        <div className={`${DEFAULT_NAME}-footer`}>
          <Button
            className={`${DEFAULT_NAME}-cancel`}
            onClick={onClose}
          >
            {intl.t('mario.button.cancel')}
          </Button>
          <Button
            className={`${DEFAULT_NAME}-confirm`}
            type="primary"
            danger
            onClick={handleConfirm}
          >
            {intl.t('mario.button.delete')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
